module.exports = __webpack_public_path__ + "static/media/expressionless-face.0da70db4.svg";